import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    LocationLimitation: {
        id: 'Components.InsuranceList.LocationLimitation',
        defaultMessage: 'Only participates at {locations}',
    },
    ProviderLimitation: {
        id: 'Components.InsuranceList.ProviderLimitation',
        defaultMessage: 'Only accepted by {providers}',
    },
});

